import { render, staticRenderFns } from "./menu-sales-query.vue?vue&type=template&id=500fc3bc&"
import script from "./menu-sales-query.vue?vue&type=script&lang=js&"
export * from "./menu-sales-query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports